var l = typeof global == "object" && global && global.Object === Object && global;
export {
  l as default
};
